import React from "react";

const Footer = () => {
  return (
    <div className="footer alert-secondary bg-dark">
      <p>
        This site was create by JPM using <b>Create-React-App</b> and{" "}
        <b>Bootstrap</b>, saved to a <b>Github repo</b> and auto deployed using{" "}
        <b>Netlify</b>. All these tools are free and open source!
      </p>
    </div>
  );
};

export default Footer;
